import { Injectable } from '@angular/core';
import {Configuration, UserCredentials} from '../models';
import {AppConfig} from '@app/shared/services/app.config';

@Injectable()
export class CookieService {
  private userCredentials: UserCredentials;
  private Config: Configuration;

  constructor() {
    this.Config = AppConfig.config;
  }

  public getCookies(forceUpdate: boolean = false): UserCredentials {
    if (!this.userCredentials || forceUpdate) {
      return this.refreshCookies();
    }
    return this.userCredentials;
  }

  public writeNotifyPopCookie(value, lifeTimeCookie) {
    this.setCookieNotify('isNotifyPop', value, lifeTimeCookie);
  }

  public writeStudyPopCookie(value, lifeTimeCookie) {
    this.setCookieNotify('isStudyPop', value, lifeTimeCookie);
  }

  public writeRecipesPageCookie(page, options = null) {
    this.setCookie('RecipesPage', page, options);
  }

  public writeScrollPosition(scrollTop, options = null) {
    this.setCookie('recipesListScrollTop', scrollTop, options);
  }

  public clearScrollPosition() {
    if (this.getCookie('recipesListScrollTop')) {
      this.setCookie('recipesListScrollTop', '0', {expires: -1, path: '/'});
      this.setCookie('RecipesPage', 1, {expires: -1, path: '/'});
    }
  }

  public writeCookies(credentials: UserCredentials, Id_Session: string, options = null) {
    this.setCookie('SessionId', Id_Session, options);
    this.setCookie('UserId', credentials.Id_User, options);
    this.setCookie('IdTarif', credentials.Id_Tarif, options);
    this.setCookie('ExternalSystem', credentials.ExternalSystem, options);
    this.setCookie('Region', credentials.Region, options);

    this.refreshCookies();
  }

  public writeRegionCookies(region, options = null) {
    this.setCookie('Region', region, options);
    this.refreshCookies();
  }

  public clearCookies(): Promise<UserCredentials> {
    return new Promise(resolve => {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        this.setCookie(name, '', {
          expires: -1, path: '/'
        });
      }
      this.setCookieNotify('isNotifyPop', '', -1);
      // this.setCookieNotify('Region', '', -1);
      this.userCredentials = null;
      resolve(this.userCredentials);
    });
  }

  private refreshCookies(): UserCredentials {
    const sessionId = this.getCookie('SessionId');
    if (sessionId) {
      this.userCredentials = new UserCredentials();
      this.userCredentials.Id_Session = sessionId;
      this.userCredentials.Id_User = isNaN(+this.getCookie('UserId')) ? null : +this.getCookie('UserId');
      this.userCredentials.Id_Tarif = isNaN(+this.getCookie('IdTarif')) ? null : +this.getCookie('IdTarif');
      // this.userCredentials.Region = this.getCookie('Region') ? null : this.getCookie('Region');
      this.userCredentials.Region = this.getCookie('Region');
      this.userCredentials.ExternalSystem = this.getCookie('ExternalSystem');
    }
    return this.userCredentials;
  }

  public getCookie(name) {
    const matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  private setCookie(name, value, options) {
    options = options || {};

    let expires = options.expires;

    if (typeof expires === 'number' && expires) {
      const d = new Date();
      d.setTime(d.getTime() + expires);
      expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = name + '=' + value;

    for (const propName in options) {
      if (propName !== null) {
        updatedCookie += '; ' + propName;
        const propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
    }

    document.cookie = updatedCookie;
  }

  private setCookieNotify(name, value, lifeTimeCookie) {
    const expire = new Date();
    expire.setTime(expire.getTime() + lifeTimeCookie);
    value = encodeURIComponent(value);
    document.cookie = `${name}=${value}; expires=${expire.toUTCString()}; path=/`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cookie.service.ts